(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolongation/views/prolongation.js') >= 0) return;  svs.modules.push('/components/numbergames/prolongation/views/prolongation.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.prolongation=_svs.numbergames.prolongation||{};
_svs.numbergames.prolongation.templates=_svs.numbergames.prolongation.templates||{};
svs.numbergames.prolongation.templates.prolongation = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"prolongableWagersRegion\"class=\"grid-row gutter-xs-2 gutter-md-4\"></div>\n<div class=\"align-center prolongation-branding-fc\">\n  <div id=\"prolongFooterRegion\"></div>\n</div>\n<div id=\"prolongGameRegion\"></div>";
},"useData":true});
Handlebars.partials['components-numbergames-prolongation-prolongation'] = svs.numbergames.prolongation.templates.prolongation;
})(svs, Handlebars);


 })(window);